var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.disabled)?_c('section',{staticClass:"cm-section"},[_c('h3',{staticClass:"cm-section__title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"cm-section__content"},[_vm._t("default")],2)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }